/* === КОНФИГУРАЦИЯ УРОВНЕЙ === */
const LEVELS_CONFIG = [
  {
    id: 'mini',
    threshold: 10000, // €100.00 in cents
    activeText: 'Nog {left} excl. btw te gaan voor een GRATIS Mini Goodie Bag. Geldig vanaf €100,- excl. btw na korting.',
    doneText: '🎁 Bij een ordertotaal van €100,- excl. btw na korting ontvang je automatisch een GRATIS Mini Goodie Bag. Kortingen die nog worden toegepast kunnen invloed hebben op deze actie.',
    images: [ // МАССИВ картинок для слайдера
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_JULY_SPECIAL.png?v=1784278875',
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_ITEM_001.png?v=1768306095',
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_ITEM_002.png?v=1768306095',
    ]
  },
  {
    id: 'standard',
    threshold: 15000, // €150.00
    activeText: 'Nog {left} excl. btw te gaan voor een GRATIS Standard Goodie Bag. Geldig vanaf €150,- excl. btw na korting.',
    doneText: '🎁 Bij een ordertotaal van €150,- excl. btw na korting ontvang je automatisch een GRATIS Standard Goodie Bag. Kortingen die nog worden toegepast kunnen invloed hebben op deze actie.',
    images: [
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_NO_BG.png?v=1768148982',
    ]
  },
  {
    id: 'premium',
    threshold: 20000, // €200.00
    activeText: 'Nog {left} excl. btw te gaan voor een GRATIS Premium Goodie Bag. Geldig vanaf €200,- excl. btw na korting.',
    doneText: '🎁 Bij een ordertotaal van €200,- excl. btw na korting ontvang je automatisch een GRATIS Premium Goodie Bag. Kortingen die nog worden toegepast kunnen invloed hebben op deze actie.',
    images: [
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_VIP_NO_BG.png?v=1770641999',
    ]
  },

  // Добавляйте новые уровни здесь по той же схеме
];

/* === НАСТРОЙКИ === */
const FS_SYMBOL = '€';

/* === КОНФИГУРАЦИЯ БОНУСНЫХ НАБОРОВ (level.txt) === */
// Ключ атрибута корзины, куда сохраняется выбор — виден в заказе в админке
// (Additional details), НЕ печатается в инвойсе/чеке клиента. Машинный стиль
// (snake_case, без пробела) — специально такой же, как key у metafield
// custom.gekozen_bonus в Shopify, чтобы сравнение в Flow было 1-в-1, без
// пробелов/регистра, которые легко разъехались бы между JS и Flow.
const BONUS_ATTRIBUTE_KEY = 'gekozen_bonus';

// Каждый option — { image, parts }.
// image — общее фото набора целиком (сверху карточки), загружено в Shopify
// Settings → Files, ссылки на cdn.shopify.com.
// parts — массив "частей" набора (напильник / полумесяц / цвет) для мелких
// карточек внутри; часть — либо строка, либо { label, image } под фото части.
const BONUS_TIERS = [
  {
    threshold: 10000, // €100.00 excl. btw
    label: 'Vanaf €100 excl. btw',
    options: [
      { image: 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/001_MINI_GOODIEBAG_VIJL_GLITTER_086.png?v=1791023623', parts: ['Vijl 220/240 grit (1x)', 'halve maan', 'Glitter 086'] },
      { image: 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/002_MINI_GOODIEBAG_VIJL_GLITTER_294.png?v=1791023623', parts: ['Vijl 220/240 grit (1x)', 'halve maan', 'Glitter 294'] },
      { image: 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/003_MINI_GOODIEBAG_VIJL_GLITTER_297.png?v=1791023623', parts: ['Vijl 220/240 grit (1x)', 'halve maan', 'Glitter 297'] }
    ]
  },
  {
    threshold: 15000, // €150.00 excl. btw
    label: 'Vanaf €150 excl. btw',
    options: [
      { image: 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/004_STANDARD_GOODIEBAG_VIJL_TGEL_IC6.png?v=1791023622', parts: ['Vijl 220/240 grit (1x)', 'halve maan', 'Mini T-Gel Intensive Cover 6'] },
      { image: 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/005_STANDARD_GOODIEBAG_VIJL_TGEL_C5.png?v=1791023622', parts: ['Vijl 220/240 grit (1x)', 'halve maan', 'Mini T-Gel Cover 5'] },
      { image: 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/006_STANDARD_GOODIEBAG_VIJL_BUILDERGEL_C1.png?v=1791023622', parts: ['Vijl 220/240 grit (1x)', 'halve maan', 'Mini Builder Gel Cover 1'] }
    ]
  },
  {
    threshold: 20000, // €200.00 excl. btw
    label: 'Vanaf €200 excl. btw',
    options: [
      { image: 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/007_PREMIUM_GOODIEBAG_VIJL_GELPOLISH_004.png?v=1791023622', parts: ['Vijl 220/240 grit (1x)', 'halve maan', 'Gel Polish 004'] },
      { image: 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/008_PREMIUM_GOODIEBAG_VIJL_GELPOLISH_116.png?v=1791023622', parts: ['Vijl 220/240 grit (1x)', 'halve maan', 'Gel Polish 116'] },
      { image: 'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/009_PREMIUM_GOODIEBAG_VIJL_GELPOLISH_014.png?v=1793283127', parts: ['Vijl 220/240 grit (1x)', 'halve maan', 'Gel Polish 014'] }
    ]
  }
  // Добавляйте новые пороги здесь по той же схеме
];

/* === АКЦИЯ (полная временная подмена уровней) ===
   Пока "сейчас" (по времени Europe/Amsterdam, не по времени браузера
   посетителя) попадает в окно одного из периодов ниже — ВЕСЬ обычный
   функционал (3 уровня прогресс-бара + выбор бонуса из LEVELS_CONFIG/
   BONUS_TIERS) полностью отключается, работает только то, что описано
   здесь: один уровень прогресс-бара и ОДИН фиксированный бонус без выбора
   (сам пишется в cart attribute, как только сумма достигает порога).
   Как только окно заканчивается — всё само возвращается к обычным трём
   уровням, ничего переключать вручную не надо. */
const PROMO_PERIODS = [
  {
    id: 'weekend-oct-2026',
    startDate: '2026-10-10T00:01:00', // Europe/Amsterdam
    endDate:   '2026-10-12T23:59:00', // Europe/Amsterdam
    threshold: 30000, // €300.00 excl. btw
    bagName: 'TS NAILS Goodiebag (t.w.v. €75,-)', // короткое название для карточки-превью
    // Состав — отдельным списком (не строкой), чтобы показать его боксами в
    // карточке, как у обычных уровней, и чтобы bonusText (ниже, через
    // promoBonusText) собирался из того же источника, без дублирования.
    items: ['T-Gel (5g)', 'Liquid AcryGel (5g)', 'Builder Gel (15g)', 'Gelpolish 241', 'Skin Bliss Handcréme (50ml)', 'Flakes', 'Vijlenset', 'Folie Bladgoud', 'Cuticle Bliss (10ml)', 'TS NAILS sleutelhanger'],
    activeText: 'Nog {left} excl. btw te gaan voor onze GRATIS TS NAILS Goodiebag (t.w.v. €75,-)! Dit weekend alleen, geldig vanaf €300,- excl. btw na korting.',
    doneText: '🎁 Je hebt onze GRATIS TS NAILS Goodiebag (t.w.v. €75,-) verdiend! Kortingen die nog worden toegepast kunnen invloed hebben op deze actie.',
    // Обычная картинка-коробка рядом с прогресс-баром (та же, что и у
    // остальных уровней) — реальное фото состава тут не нужно, оно и так
    // показано в карточке ниже через promoCardImages.
    images: [
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/GOODIEBAG_NO_BG.png?v=1768148982'
    ],
    // Реальное фото состава — используется ТОЛЬКО в карточке-превью бонуса ниже
    promoCardImages: [
      'https://cdn.shopify.com/s/files/1/0820/8311/9416/files/Goodiebag_Oct_2026_optimized.png?v=1791536289'
    ]
  }

  // Добавляйте новые акционные периоды здесь по той же схеме
];

// Цвет акционного блока — отдельный от обычных 4 (оранжевый/зелёный/синий/
// фиолетовый), чтобы визуально сразу было видно "это не обычный уровень"
const PROMO_COLORS = { fill: '#E91E63', bg: '#FDE4EC' };

// Текущее время по Europe/Amsterdam, а не по времени браузера посетителя —
// чтобы акция стартовала/заканчивалась в один и тот же момент для всех,
// независимо от часового пояса покупателя.
function nowInAmsterdam() {
  return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
}

// Есть ли прямо сейчас активный акционный период
function getActivePromo() {
  const now = nowInAmsterdam();
  return PROMO_PERIODS.find(p => now >= new Date(p.startDate) && now <= new Date(p.endDate)) || null;
}

// Текст для cart attribute — собирается из bagName + items, тот же формат
// "Название: состав через запятую", что и bonusOptionText для обычных уровней.
function promoBonusText(promo) {
  return promo.bagName + ': ' + (promo.items || []).join(', ');
}

/* === ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ === */

// Форматирование денег из центов — запятая вместо точки (nl-NL), чтобы
// совпадало с остальным текстом на сайте ("€150,-" и т.п.)
function fsFmt(cents) {
  return FS_SYMBOL + (cents / 100).toFixed(2).replace('.', ',');
}

// Получить корзину
async function fsGetCart() {
  const r = await fetch('/cart.js', { credentials: 'same-origin' });
  return r.json();
}

// Проверка, активен ли уровень по датам
function isLevelActive(level) {
  const now = new Date();
  const start = level.startDate ? new Date(level.startDate) : null;
  const end = level.endDate ? new Date(level.endDate) : null;

  if (start && now < start) return false;
  if (end && now >= end) return false;

  return true;
}

// Найти текущий активный уровень на основе суммы корзины
function getCurrentLevel(cartTotal) {
  // Фильтруем активные уровни по датам
  const activeLevels = LEVELS_CONFIG.filter(isLevelActive);
  
  if (activeLevels.length === 0) return null;

  // Сортируем по порогу (от меньшего к большему)
  activeLevels.sort((a, b) => a.threshold - b.threshold);
  
  // Ищем первый НЕдостигнутый уровень
  for (let level of activeLevels) {
    if (cartTotal < level.threshold) {
      return level; // Показываем этот уровень
    }
  }
  
  // Если все уровни достигнуты, показываем последний (самый высокий) с поздравлением
  return activeLevels[activeLevels.length - 1];
}

// Слайдер картинок с плавной сменой
let currentSliderInterval = null;

function startImageSlider(imgElement, images) {
  // Останавливаем предыдущий слайдер
  if (currentSliderInterval) {
    clearInterval(currentSliderInterval);
  }

  if (!images || images.length === 0) return;

  let currentIndex = 0;
  
  // Устанавливаем первую картинку
  imgElement.src = images[0];
  imgElement.style.transition = 'opacity 0.5s ease-in-out';
  imgElement.style.opacity = '1';

  // Если только одна картинка - не запускаем слайдер
  if (images.length === 1) return;

  // Запускаем интервал смены картинок
  currentSliderInterval = setInterval(() => {
    imgElement.style.opacity = '0';
    
    setTimeout(() => {
      currentIndex = (currentIndex + 1) % images.length;
      imgElement.src = images[currentIndex];
      imgElement.style.opacity = '1';
    }, 500);
    
  }, 2000); // Меняем каждые 2 секунды
}

// Анимированные диагональные полосы на заливке — как progress-bar-striped
// progress-bar-animated в Bootstrap. Инжектим один раз, до любого бонусного
// порога (в отличие от bp-стилей, прогресс-бар виден с самого начала).
let fsStyleInjected = false;
function ensureFsStyle() {
  if (fsStyleInjected) return;
  fsStyleInjected = true;
  const style = document.createElement('style');
  style.textContent =
    '.fs-track{height:22px!important;border-radius:11px!important;overflow:hidden}' +
    '.fs-fill{' +
    'height:100%!important;border-radius:11px!important;' +
    'display:flex!important;align-items:center;justify-content:center;overflow:hidden;' +
    'background-image:linear-gradient(45deg,rgba(255,255,255,.35) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.35) 50%,rgba(255,255,255,.35) 75%,transparent 75%,transparent);' +
    'background-size:1rem 1rem;' +
    'animation:fs-stripes 1s linear infinite}' +
    '@keyframes fs-stripes{from{background-position:1rem 0}to{background-position:0 0}}' +
    '.fs-fill-label{color:#fff;font-size:11px;font-weight:700;white-space:nowrap;padding:0 6px;text-shadow:0 1px 1px rgba(0,0,0,.25)}';
  document.head.appendChild(style);
}

/* === СОЗДАНИЕ HTML ДЛЯ УРОВНЯ === */

function createLevelHTML(level) {
  return `
    <div class="fs-wrapper">
      <div class="fs-image-bg">
        <img src="" alt="Gift product" class="fs-product-img">
      </div>
      <div class="fs-content">
        <div class="fs-track">
          <div class="fs-fill"><span class="fs-fill-label"></span></div>
        </div>
        <p class="fs-msg"></p>
      </div>
    </div>
  `;
}

/* === БОНУСНЫЙ ВЫБОР (level.txt) === */

// Найти самый высокий уже достигнутый порог по сумме корзины
function getHighestReachedTier(cartTotal) {
  let result = null;
  for (const tier of BONUS_TIERS) {
    if (cartTotal >= tier.threshold) result = tier;
  }
  return result;
}

// Цвет объединённого блока (прогресс-бар + выбор бонуса) в зависимости от
// того, какой порог уже достигнут — fill (насыщенный) и bg (светлый) из одной
// пары, используется и в fsRender(), и в fsRenderBonusPicker(), чтобы оба
// всегда красились синхронно.
const TIER_COLORS = {
  none:  { fill: '#FF9800', bg: '#FFE9CC' }, // ещё ничего не достигли — оранжевый
  10000: { fill: '#4CAF50', bg: '#E3F5E1' }, // Mini (€100) — зелёный
  15000: { fill: '#2196F3', bg: '#E1EDFB' }, // Standard (€150) — синий
  20000: { fill: '#9C27B0', bg: '#F1E3FB' }  // Premium (€200) — фиолетовый
};
function getTierColors(cartTotal) {
  const tier = getHighestReachedTier(cartTotal);
  return tier ? (TIER_COLORS[tier.threshold] || TIER_COLORS.none) : TIER_COLORS.none;
}

// Название набора по порогу — то же самое, что и в LEVELS_CONFIG (id: 'mini'/'standard'/'premium')
const TIER_BAG_NAME = {
  10000: 'Mini Goodie Bag',
  15000: 'Standard Goodie Bag',
  20000: 'Premium Goodie Bag'
};

// Часть набора — строка или { label, image }.
function bonusPartLabel(part) {
  return typeof part === 'string' ? part : part.label;
}
// Текст для cart attribute: все части, кроме последней, через пробел
// ("Vijl 220/240 grit (1x) halve maan"), и только перед последней — " + "
// ("... + Glitter 086"). Формат зафиксирован в Shopify Flow, не менять просто так.
function bonusOptionText(option) {
  const labels = option.parts.map(bonusPartLabel);
  if (labels.length <= 1) return labels.join('');
  return labels.slice(0, -1).join(' ') + ' + ' + labels[labels.length - 1];
}

// "Память" о выборе на каждом уровне живёт в localStorage браузера, а НЕ в
// cart attributes — иначе все когда-либо выбранные варианты (по одному на
// уровень) улетали бы в заказ вместе с "главным" полем, засоряя Additional
// details у Shopify. В заказ должно попадать ровно одно поле — BONUS_ATTRIBUTE_KEY.
function bonusTierStorageKey(tier) {
  return 'cw_bonus_' + tier.threshold;
}
function bonusLocalGet(tier) {
  try { return localStorage.getItem(bonusTierStorageKey(tier)) || ''; }
  catch (e) { return ''; }
}
// Корзину полностью очистили — это новая покупка, старые "запомненные"
// выборы по уровням больше не должны молча подставляться в следующий раз.
function bonusLocalClearAll() {
  try {
    BONUS_TIERS.forEach(tier => localStorage.removeItem(bonusTierStorageKey(tier)));
  } catch (e) {}
}
function bonusLocalSet(tier, value) {
  try { localStorage.setItem(bonusTierStorageKey(tier), value); }
  catch (e) {}
}

// Сохраняет выбор ТОЛЬКО в "главный" BONUS_ATTRIBUTE_KEY — единственное
// поле, которое реально попадает в cart attributes и дальше в заказ
// (и которое читает Shopify Flow). На инвойс/чек клиента не печатается.
async function fsSaveBonusChoice(value) {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { [BONUS_ATTRIBUTE_KEY]: value } })
  });
}

function createBonusPickerHTML(tier) {
  const rows = tier.options.map(option => {
    // 2 карточки, не 3: первая — цветной/гелевый пункт (отличается в каждом
    // варианте), вторая — общие для всех вариантов напильник + полумесяц,
    // каждый своим <span> внутри одной рамки (чтобы строка не была длинной).
    // На сохранённый текст бонуса (bonusOptionText) это не влияет — там
    // порядок и разбивка остаются прежними (важно для Shopify Flow).
    const colorPart = option.parts[option.parts.length - 1];
    const restParts = option.parts.slice(0, -1);
    const colorImage = typeof colorPart === 'object' ? colorPart.image : null;

    const partsHTML = `
      <div class="bp-part">
        ${colorImage ? `<img src="${colorImage}" alt="${bonusPartLabel(colorPart)}" class="bp-part-img">` : ''}
        <span class="bp-part-label">${bonusPartLabel(colorPart)}</span>
      </div>
      <div class="bp-part">
        ${restParts.map(p => `<span class="bp-part-label">${bonusPartLabel(p)}</span>`).join('')}
      </div>
    `;

    return `
      <label class="bp-option">
        ${option.image ? `<img src="${option.image}" alt="" class="bp-option-img">` : ''}
        <div class="bp-parts">${partsHTML}</div>
        <input type="radio" name="bp-choice">
      </label>
    `;
  }).join('');

  const amount = tier.threshold / 100;
  const bagName = TIER_BAG_NAME[tier.threshold] || 'Goodie Bag';
  return `
    <div class="bp-wrapper">
      <p class="bp-title">Kies je gratis bonus (${tier.label}):</p>
      <div class="bp-options">${rows}</div>
      <ul class="bp-disclaimer">
        <li>Om een <strong>${bagName}</strong> te ontvangen moet uw ordertotaal excl. btw €${amount} of meer bedragen.</li>
        <li>Als het bedrag excl. btw na toepassing van een kortingscode of andere korting lager uitvalt dan €${amount}, wordt de <strong>${bagName}</strong> niet toegekend.</li>
      </ul>
    </div>
  `;
}

// Карточка-превью акционного бонуса — без выбора, просто "приз", который
// визуально из серого/приглушённого становится цветным, когда порог достигнут
// (переключение класса is-unlocked делает fsRenderBonusPicker, тут только разметка).
function createPromoCardHTML(promo) {
  const img = promo.promoCardImages && promo.promoCardImages[0] ? promo.promoCardImages[0] : '';
  const amount = promo.threshold / 100;
  const itemsHTML = (promo.items || [])
    .map(item => `<div class="bp-part"><span class="bp-part-label">${item}</span></div>`)
    .join('');
  return `
    <div class="bp-wrapper">
      <p class="bp-title">Jouw gratis bonus bij €${amount}:</p>
      <div class="bp-options">
        <div class="bp-option bp-promo-card">
          ${img ? `<img src="${img}" alt="" class="bp-option-img">` : ''}
          <span class="bp-part-label">${promo.bagName}</span>
          <div class="bp-parts">${itemsHTML}</div>
          <span class="bp-promo-status"></span>
        </div>
      </div>
      <ul class="bp-disclaimer">
        <li>Om een <strong>${promo.bagName}</strong> te ontvangen moet uw ordertotaal excl. btw €${amount} of meer bedragen.</li>
        <li>Als het bedrag excl. btw na toepassing van een kortingscode of andere korting lager uitvalt dan €${amount}, wordt de <strong>${promo.bagName}</strong> niet toegekend.</li>
      </ul>
    </div>
  `;
}

// Простые1 стили на случай, если их нет в теме — инжектим один раз.
// Задача: визуально слить с карточкой прогресс-бара (.fs-wrapper) в один блок —
// когда бонус-пикер показан, у прогресс-бара сверху снимаются нижние скругления
// (класс .bp-merged, см. fsRenderBonusPicker), а .bp-wrapper красится в тот же
// серый фон и продолжает карточку снизу без зазора.
let bpStyleInjected = false;
function ensureBonusPickerStyle() {
  if (bpStyleInjected) return;
  bpStyleInjected = true;
  const style = document.createElement('style');
  style.textContent =
    '#progress-levels-container{margin-bottom:0!important}' +
    '.fs-wrapper.bp-merged{border-radius:12px 12px 0 0!important;margin-bottom:0!important;box-shadow:none!important}' +
    '.bp-wrapper{background:#f5f5f5;border-radius:0 0 12px 12px;padding:16px;margin:0;container-type:inline-size}' +
    '.bp-title{font-weight:600;margin:0 0 10px;font-size:14px}' +
    '.bp-disclaimer{margin:12px 0 0;padding-left:16px;font-size:11px;line-height:1.4;color:#777;text-align:left!important}' +
    '.bp-disclaimer li{margin-bottom:4px;text-align:left!important}' +
    '.bp-disclaimer li:last-child{margin-bottom:0}' +
    '.bp-options{display:flex;gap:10px;align-items:stretch}' +
    '.bp-option{display:flex;flex-direction:column;align-items:center;gap:6px;flex:1;min-width:0;padding:8px;border:1px solid #ddd;border-radius:8px;background:#fff;cursor:pointer;transition:border-color .15s ease,background .15s ease}' +
    '.bp-option.is-selected{background:#eef7ee}' +
    '.bp-option input{flex:none}' +
    '.bp-option-img{display:block;width:100%;max-width:140px;border-radius:6px;object-fit:contain}' +
    '.bp-parts{display:flex;flex-direction:column;gap:6px;width:100%}' +
    '.bp-part{border:1px solid #e5e5e5;border-radius:6px;padding:6px 4px;text-align:center;background:#fafafa}' +
    '.bp-part-img{display:block;width:100%;max-width:64px;height:64px;object-fit:contain;margin:0 auto 6px}' +
    '.bp-part-label{display:block;font-size:12px;line-height:1.25;word-break:break-word}' +
    // Всегда 3 колонки в ряд, даже на узкой панели/телефоне — не растягиваем
    // блок по высоте. Вместо переключения в столбец просто ужимаем отступы
    // и шрифт на маленькой ширине контейнера (не окна — @container).
    '@container (max-width:420px){.bp-option{padding:6px;gap:4px}.bp-part{padding:5px 3px}.bp-part-label{font-size:10.5px}.bp-option-img{max-width:90px}}' +
    '@media(max-width:420px){.bp-option{padding:6px;gap:4px}.bp-part{padding:5px 3px}.bp-part-label{font-size:10.5px}.bp-option-img{max-width:90px}}' +
    '.cw-checkout-note{margin-top:8px;font-size:12px;color:#c0392b}' +
    // Акционная карточка-превью: серая/приглушённая, пока порог не достигнут,
    // цветная + статус зелёным, как только достигнут — геймификация "приз открыт"
    '.bp-promo-card{cursor:default;max-width:320px;margin:0 auto}' +
    '.bp-promo-card .bp-option-img{filter:grayscale(1) opacity(.45);transition:filter .5s ease}' +
    '.bp-promo-card.is-unlocked .bp-option-img{filter:none}' +
    '.bp-promo-card .bp-part-label{opacity:.55;transition:opacity .5s ease,font-weight .5s ease}' +
    '.bp-promo-card.is-unlocked .bp-part-label{opacity:1;font-weight:700}' +
    '.bp-promo-card .bp-part{opacity:.6;transition:opacity .5s ease}' +
    '.bp-promo-card.is-unlocked .bp-part{opacity:1}' +
    '.bp-promo-status{display:block;margin-top:4px;font-size:11px;font-weight:700;color:#999;transition:color .5s ease}' +
    '.bp-promo-card.is-unlocked .bp-promo-status{color:#2e7d32}' +
    // Конфетти при разблокировке — полноэкранный слой поверх всего (не мешает
    // кликам, сам исчезает через ~4с вместе с JS-таймером в fireConfetti())
    '.cw-confetti-box{position:fixed;inset:0;pointer-events:none;z-index:2147483647;overflow:hidden}' +
    '.cw-confetti-piece{position:absolute;top:-12px;width:8px;height:14px;border-radius:2px;opacity:.9;animation-name:cw-confetti-fall;animation-timing-function:ease-in;animation-fill-mode:forwards}' +
    '@keyframes cw-confetti-fall{0%{transform:translateY(0) rotate(0deg);opacity:1}100%{transform:translateY(100vh) rotate(var(--r,360deg));opacity:0}}';
  document.head.appendChild(style);
}

// Блокировка кнопки(-ок) оформления заказа, пока не выбран бонус — актуально
// только на самой странице корзины (не чекаут), и только когда реально есть
// порог, на котором бонус положен. button[name="checkout"] — это реальная
// кнопка в теме (checkout-button checkout-button--lower); остальное в списке —
// запасные варианты на случай других тем.
const CHECKOUT_BUTTON_SELECTOR =
  'button[name="checkout"], input[name="checkout"], ' +
  '#checkout, .checkout-button, .cart__checkout-button, .cart-checkout-button, .checkout-btn';

function fsUpdateCheckoutLock(blocked) {
  document.querySelectorAll(CHECKOUT_BUTTON_SELECTOR).forEach(btn => {
    btn.disabled = blocked;
    btn.style.opacity = blocked ? '.5' : '';
    btn.style.cursor = blocked ? 'not-allowed' : '';

    if (!btn.dataset.cwNoteAdded) {
      const note = document.createElement('div');
      note.className = 'cw-checkout-note';
      note.textContent = 'Kies eerst je gratis bonus hierboven om af te rekenen.';
      note.style.display = 'none';
      btn.insertAdjacentElement('afterend', note);
      btn.dataset.cwNoteAdded = '1';
    }
    const note = btn.nextElementSibling;
    if (note && note.classList.contains('cw-checkout-note')) {
      note.style.display = blocked ? '' : 'none';
    }
  });
}

// Конфетти в момент разблокировки акционного бонуса. Запускаем один раз,
// именно в момент перехода "ещё не хватало" -> "хватило", а не на каждый
// рендер и не при самой первой загрузке страницы (если корзина уже выше
// порога) — для этого promoWasUnlocked стартует с null, а не false.
let promoWasUnlocked = null;
function fireConfetti() {
  const colors = ['#E91E63', '#FF9800', '#4CAF50', '#2196F3', '#9C27B0', '#FFC107'];
  const box = document.createElement('div');
  box.className = 'cw-confetti-box';
  document.body.appendChild(box);

  for (let i = 0; i < 70; i++) {
    const piece = document.createElement('span');
    piece.className = 'cw-confetti-piece';
    piece.style.left = Math.random() * 100 + 'vw';
    piece.style.background = colors[Math.floor(Math.random() * colors.length)];
    piece.style.animationDelay = (Math.random() * 0.4) + 's';
    piece.style.animationDuration = (2 + Math.random() * 1.5) + 's';
    piece.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg');
    box.appendChild(piece);
  }

  setTimeout(() => box.remove(), 4000);
}

async function fsRenderBonusPicker() {
  try {
    const cart = await fsGetCart();
    const total = cart?.total_price || 0;

    const container = document.getElementById('bonus-picker-container');
    if (!container) return;

    const progressWrapper = document.querySelector('#progress-levels-container .fs-wrapper');

    const promo = getActivePromo();
    if (promo) {
      // Во время акции — без выбора, один фиксированный бонус, но карточку
      // всё равно показываем (как "превью приза") — серую/приглушённую,
      // пока порог не достигнут, и "вспыхивающую" цветом, как только
      // достигнут. Сшиваем с прогресс-баром в один блок, как и обычный пикер.
      container.style.display = '';
      ensureBonusPickerStyle();
      if (progressWrapper) progressWrapper.classList.add('bp-merged');
      fsUpdateCheckoutLock(false); // выбирать нечего — чекаут никогда не блокируем

      const unlocked = total >= promo.threshold;

      // DOM карточки строим один раз, не на каждый рендер — иначе пересборка
      // сама спровоцирует наш же MutationObserver по кругу (та же причина,
      // по которой обычный пикер тоже перестраивается только при смене уровня).
      if (container.dataset.tier !== promo.id) {
        container.dataset.tier = promo.id;
        container.innerHTML = createPromoCardHTML(promo);
      }
      const card = container.querySelector('.bp-promo-card');
      if (card) {
        card.classList.toggle('is-unlocked', unlocked);
        const status = card.querySelector('.bp-promo-status');
        if (status) status.textContent = unlocked ? '✓ Ontgrendeld!' : '🔒 Nog niet ontgrendeld';
      }
      const bpWrapper = container.querySelector('.bp-wrapper');
      if (bpWrapper) bpWrapper.style.backgroundColor = PROMO_COLORS.bg;

      // Конфетти ровно в момент перехода в разблокированное состояние
      if (promoWasUnlocked === false && unlocked) {
        fireConfetti();
      }
      promoWasUnlocked = unlocked;

      const shouldHave = unlocked ? promoBonusText(promo) : '';
      if ((cart?.attributes?.[BONUS_ATTRIBUTE_KEY] || '') !== shouldHave) {
        fsSaveBonusChoice(shouldHave);
      }
      return;
    }

    const tier = getHighestReachedTier(total);
    if (!tier) {
      container.style.display = 'none';
      container.innerHTML = '';
      delete container.dataset.tier;
      if (progressWrapper) progressWrapper.classList.remove('bp-merged');
      fsUpdateCheckoutLock(false); // ниже порога бонуса нет — чекаут не блокируем
      // Сумма упала ниже САМОГО первого порога — ни один бонус больше не
      // положен. Если в "главном" атрибуте всё ещё висит старый выбор
      // (человек добавил товаров, выбрал бонус, потом всё убрал) — чистим,
      // иначе в заказ на копейки улетит бонус уровня Premium.
      if (cart?.attributes?.[BONUS_ATTRIBUTE_KEY]) {
        fsSaveBonusChoice('');
      }
      // Корзина совсем пустая (не просто ниже €100, а реально 0 товаров) —
      // это явный сигнал "новая покупка", стираем и локальную память по
      // уровням, чтобы старый выбор не подставился молча в следующий раз.
      if (total === 0) {
        bonusLocalClearAll();
      }
      return;
    }
    container.style.display = '';
    ensureBonusPickerStyle();
    if (progressWrapper) progressWrapper.classList.add('bp-merged');

    const colors = getTierColors(total);

    // Подсветка выбранной карточки — цветом текущего уровня (не всегда зелёным)
    function markSelected(row, isSelected) {
      row.classList.toggle('is-selected', isSelected);
      row.style.borderColor = isSelected ? colors.fill : '';
      row.style.backgroundColor = isSelected ? colors.bg : '';
    }

    // Перестраиваем DOM только когда реально сменился порог — иначе каждый
    // fsRenderBonusPicker() пересоздавал бы радиокнопки и рвал клик (и заодно
    // сам себя дёргал через MutationObserver по кругу).
    if (container.dataset.tier !== String(tier.threshold)) {
      container.dataset.tier = String(tier.threshold);
      container.innerHTML = createBonusPickerHTML(tier);

      container.querySelectorAll('.bp-option').forEach((row, i) => {
        row.addEventListener('click', async () => {
          const value = bonusOptionText(tier.options[i]);
          container.querySelectorAll('.bp-option').forEach(r => markSelected(r, false));
          markSelected(row, true);
          bonusLocalSet(tier, value); // запоминаем локально (только этот браузер)
          await fsSaveBonusChoice(value); // и пишем в единственное поле заказа
        });
        // Hover тоже цветом уровня, а не статичным CSS (иначе он всегда зелёный)
        row.addEventListener('mouseenter', () => {
          if (!row.classList.contains('is-selected')) row.style.borderColor = colors.fill;
        });
        row.addEventListener('mouseleave', () => {
          if (!row.classList.contains('is-selected')) row.style.borderColor = '';
        });
      });

      // Мы только что перепрыгнули на этот уровень (вверх или вниз).
      // Сначала смотрим, что РЕАЛЬНО стоит в самой корзине — если это
      // значение совпадает с одним из вариантов ЭТОГО уровня, значит выбор
      // уже сделан и подтверждён на стороне Shopify (например, человек
      // открыл ссылку восстановления брошенной корзины в другом браузере —
      // своей localStorage-памяти там нет, но в корзине выбор уже есть).
      // Корзина в этом случае главнее локальной памяти — подтягиваем её
      // значение туда, а не затираем пустотой.
      const currentAttr = cart?.attributes?.[BONUS_ATTRIBUTE_KEY] || '';
      const matchesThisTier = tier.options.some(o => bonusOptionText(o) === currentAttr);

      if (matchesThisTier) {
        bonusLocalSet(tier, currentAttr);
      } else {
        // Иначе — как раньше: вспоминаем, что выбирали на ЭТОМ уровне
        // локально, или чистим главное поле, если тут ещё ничего не выбирали.
        const storedForTier = bonusLocalGet(tier);
        if (currentAttr !== storedForTier) {
          fsSaveBonusChoice(storedForTier);
        }
      }
    }

    // Тот же фон, что и у прогресс-бара — единый блок
    const bpWrapper = container.querySelector('.bp-wrapper');
    if (bpWrapper) bpWrapper.style.backgroundColor = colors.bg;

    // Синхронизируем визуально выбранный пункт без пересборки DOM — сверяемся
    // с локальной памятью ЭТОГО уровня, а не с полем заказа, чтобы каждый
    // уровень помнил свой выбор независимо от того, что сейчас в заказе.
    const selected = bonusLocalGet(tier);
    container.querySelectorAll('.bp-option').forEach((row, i) => {
      const isSelected = bonusOptionText(tier.options[i]) === selected;
      markSelected(row, isSelected);
      const input = row.querySelector('input');
      if (input) input.checked = isSelected;
    });

    // Порог для бонуса есть — блокируем чекаут, пока для ЭТОГО уровня ничего не выбрано
    fsUpdateCheckoutLock(!selected);

  } catch (e) {
    console.warn('Bonus picker render error:', e);
  }
}

/* === ОСНОВНАЯ ЛОГИКА === */

async function fsRender() {
  try {
    // Получаем данные корзины
    const cart = await fsGetCart();
    const total = cart?.total_price || 0;

    const promo = getActivePromo();

    // Во время акции используем её собственный (единственный) уровень вместо
    // обычных LEVELS_CONFIG — вся логика ниже (слайдер, текст, % заливки)
    // работает одинаково что для обычного уровня, что для акционного.
    const currentLevel = promo
      ? { threshold: promo.threshold, activeText: promo.activeText, doneText: promo.doneText, images: promo.images }
      : getCurrentLevel(total);

    // Находим контейнер
    const container = document.getElementById('progress-levels-container');
    if (!container) return;

    // Если нет активных уровней - прячем контейнер
    if (!currentLevel) {
      container.style.display = 'none';
      return;
    }

    // Показываем контейнер
    container.style.display = '';
    ensureFsStyle();

    // Создаём HTML если его ещё нет
    if (!container.innerHTML.trim()) {
      container.innerHTML = createLevelHTML(currentLevel);
    }

    // Находим элементы внутри блока
    const wrapper = container.querySelector('.fs-wrapper');
    const fill = container.querySelector('.fs-fill');
    const msg = container.querySelector('.fs-msg');
    if (!fill || !msg) return;

    // Цвет блока и заливки — по уже достигнутому порогу
    // (оранжевый → зелёный → синий → фиолетовый, fill и фон из одной пары),
    // либо отдельный акционный цвет, пока идёт промо-период
    const colors = promo ? PROMO_COLORS : getTierColors(total);
    if (wrapper) wrapper.style.backgroundColor = colors.bg;
    fill.style.backgroundColor = colors.fill;

    // Сколько осталось до порога
    const left = Math.max(0, currentLevel.threshold - total);

    // Процент заполнения (не больше 100)
    const pct = Math.min(100, Math.round((total / currentLevel.threshold) * 100));

    // Задаём ширину прогресс-бара
    fill.style.width = pct + '%';

    // Подпись внутри заливки: сколько уже в корзине / сколько нужно для бонуса
    const label = fill.querySelector('.fs-fill-label');
    if (label) {
      const newLabel = fsFmt(total) + ' / ' + fsFmt(currentLevel.threshold);
      if (label.textContent !== newLabel) label.textContent = newLabel;
    }

    // Запускаем слайдер картинок
    const imgEl = container.querySelector('.fs-product-img');
    if (imgEl && currentLevel.images) {
      startImageSlider(imgEl, currentLevel.images);
    }

    // Выбираем состояние и текст
    let newMsg;
    if (left > 0) {
      container.classList.add('is-active');
      container.classList.remove('is-done');
      newMsg = currentLevel.activeText.replace('{left}', fsFmt(left));
    } else {
      container.classList.remove('is-active');
      container.classList.add('is-done');
      newMsg = currentLevel.doneText;
    }
    // Пишем текст, только если он реально изменился — иначе это лишняя DOM-мутация,
    // на которую среагирует наш же MutationObserver и зациклит рендер.
    if (msg.textContent !== newMsg) msg.textContent = newMsg;

  } catch (e) {
    console.warn('Progress bar render error:', e);
  }
}

/* === ИНИЦИАЛИЗАЦИЯ И ОБНОВЛЕНИЯ === */

// Общий обработчик любого изменения корзины
function fsOnCartChange() {
  fsRender();
  fsRenderBonusPicker();
}

// Первичная отрисовка при загрузке
document.addEventListener('DOMContentLoaded', fsOnCartChange);

// Перехватываем fetch к /cart/*
(function() {
  const _f = window.fetch;
  window.fetch = async function(i, init) {
    const res = await _f(i, init);
    try {
      const url = typeof i === 'string' ? i : (i?.url || '');
      if (url.includes('/cart/')) setTimeout(fsOnCartChange, 80);
    } catch (_) {}
    return res;
  };
})();

// Ловим XHR-запросы к /cart/* (jQuery/старые темы)
(function() {
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__fsIsCart = typeof url === 'string' && url.includes('/cart/');
    return origOpen.apply(this, arguments);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', () => {
      if (this.__fsIsCart) setTimeout(fsOnCartChange, 80);
    });
    return origSend.apply(this, arguments);
  };
})();

// Следим за перерисовкой cart-секции
(function() {
  const target =
    document.querySelector('[data-section-type="cart-template"]') ||
    document.querySelector('form.cart-form') ||
    document.body;

  const mo = new MutationObserver(() => {
    clearTimeout(window.__fsDebounce);
    window.__fsDebounce = setTimeout(fsOnCartChange, 60);
  });
  mo.observe(target, { subtree: true, childList: true });
})();

// События корзины
window.addEventListener('cart:updated', fsOnCartChange);
document.addEventListener('ajaxCart:updated', fsOnCartChange);
document.addEventListener('cc:cart-updated', fsOnCartChange);